import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=062e02fc&scoped=true&"
import script from "./waterfall.vue?vue&type=script&lang=js&"
export * from "./waterfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e02fc",
  null
  
)

export default component.exports